// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gbg2","buttons":"styles_buttons__24H5_"};